export default "__VITE_ASSET__B4qZZrs9__"